export default __webpack_public_path__ + "static/media/supertcm-overview.4257da29.svg";